import CustomerService from '../../../modules/customer/customerService'
import Errors from '../../../modules/shared/error/errors'
import Message from '../../../view/shared/message'
import { push } from 'redux-first-history'
import { i18n } from '../../../i18n'

const prefix = 'CUSTOMER_FORM'

const customerFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: customerFormActions.INIT_STARTED,
      })

      let record = {}

      const isEdit = Boolean(id)

      if (isEdit) {
        record = await CustomerService.find(id)
      }

      dispatch({
        type: customerFormActions.INIT_SUCCESS,
        payload: record,
      })
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: customerFormActions.INIT_ERROR,
      })

      dispatch(push('/customer'))
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: customerFormActions.CREATE_STARTED,
      })

      await CustomerService.create(values)

      dispatch({
        type: customerFormActions.CREATE_SUCCESS,
      })

      Message.success(
        i18n('entities.customer.create.success'),
      )

      dispatch(push('/customer'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: customerFormActions.CREATE_ERROR,
      })
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: customerFormActions.UPDATE_STARTED,
      })

      await CustomerService.update(id, values)

      dispatch({
        type: customerFormActions.UPDATE_SUCCESS,
      })

      Message.success(
        i18n('entities.customer.update.success'),
      )

      dispatch(push('/customer'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: customerFormActions.UPDATE_ERROR,
      })
    }
  },
}

export default customerFormActions
